export default __webpack_public_path__ + "static/media/Blog12.6.98d7e1ea.png";